import { TabLink } from 'components/common'
import { CloseIcon, LogoutIcon, MenuIcon } from 'components/icons'
import {
  useAuth,
  useNewSapBarcodeUnseenCount,
  usePriceLabelUnseenCount,
} from 'hooks'
import { useMemo, useState } from 'react'
import {
  PAGE_NEW_SAP_BARCODE,
  PAGE_PRICE_LABEL_SYNC_HISTORY,
} from 'utils/constants'
import { generateSidebarLinks } from 'utils/helpers'

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false)

  const { user, isAuthenticated, logout } = useAuth()
  const { unseenCount } = usePriceLabelUnseenCount()
  const { unseenCount: newSapBarcodeUnseenCount } =
    useNewSapBarcodeUnseenCount()

  const validLinks = useMemo(
    () => generateSidebarLinks(user?.pageAccess),
    [user?.pageAccess],
  )

  // Unread counts by page id — links without an entry render no badge.
  const badges = useMemo(
    () => ({
      [PAGE_PRICE_LABEL_SYNC_HISTORY.id]: unseenCount,
      [PAGE_NEW_SAP_BARCODE.id]: newSapBarcodeUnseenCount,
    }),
    [unseenCount, newSapBarcodeUnseenCount],
  )

  // Will get the index of first parent with children
  const firstParentWithChild = useMemo(
    () =>
      validLinks?.findIndex(
        (link) => link.children && link.children?.length > 0,
      ),
    [validLinks],
  )

  if (!isAuthenticated) {
    return <></>
  }

  return (
    <aside className="relative flex flex-col border-r-2 border-gray-200">
      {/* Sidebar Header */}
      <div className="header-top flex items-center px-6">
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="inline-flex h-4 w-4 items-center text-sidebar-secondary"
        >
          {collapsed ? <MenuIcon /> : <CloseIcon />}
        </button>
      </div>

      {/* Sidebar  */}
      <div className={`z-10 flex flex-col overflow-hidden`}>
        <div
          className={`${!collapsed ? 'w-[280px]' : 'w-16'}
        max-w-xs  overflow-hidden overflow-y-auto bg-white  px-3  py-4 transition-all duration-300`}
        >
          <ul>
            {validLinks?.map((page, index) => {
              const Icon = page?.icon

              return (
                <TabLink
                  name={page.name}
                  icon={page?.icon && <Icon />}
                  path={page.path}
                  key={page.id}
                  id={page.id}
                  badges={badges}
                  subTabs={page.children}
                  collapsed={collapsed}
                  // Returns true for first parent with children
                  defaultOpen={firstParentWithChild === index}
                />
              )
            })}

            {/* Logout */}
            <TabLink
              className="!font-bold !text-sidebar-primary"
              buttonAction={logout}
              name={'Log Out'}
              icon={<LogoutIcon />}
              collapsed={collapsed}
            />
          </ul>
        </div>
      </div>
    </aside>
  )
}

export default Sidebar
